import { replaceTempUUid } from "api/exchanges/exchangeUtils";
import type {
  ExchangeClient,
  ExchangeOperation,
  ExchangeResponse,
} from "api/exchanges/types";

type CreateNodeResponseData = {
  createProjectNode?: {
    id: string;
  };
};

type ActionOnGetCreateNodeResponseParams = {
  response: ExchangeResponse & {
    data?: CreateNodeResponseData;
  };
  queue: Set<ExchangeOperation>;
  replaceKeysMap: Map<string, string>;
};

export const actionOnGetCreateNodeResponse = ({
  response,
  queue,
  replaceKeysMap,
}: ActionOnGetCreateNodeResponseParams): void => {
  if (queue.size !== 0 && response.data?.createProjectNode) {
    const idToReplace = `temp__${response?.operation?.variables?.input?.parentId}__${response?.operation?.variables?.referencePosition}`;
    const replaceBy = response.data?.createProjectNode?.id;
    if (replaceBy) {
      replaceKeysMap.set(idToReplace, replaceBy);
    }
  }
};

type ExeCreateNodeFromQueueParams = {
  operation: ExchangeOperation;
  client: ExchangeClient;
  queue: Set<ExchangeOperation>;
  replaceKeysMap: Map<string, string>;
};

export const exeCreateNodeFromQueue = ({
  operation,
  client,
  queue,
  replaceKeysMap,
}: ExeCreateNodeFromQueueParams): void => {
  const parentId = operation.variables?.input?.parentId;
  if (parentId && parentId.startsWith("temp_")) {
    if (operation.variables && operation.variables.input) {
      operation.variables.input.parentId = replaceTempUUid({
        id: parentId,
        replaceKeysMap,
      });
    }
  }
  client.reexecuteOperation({
    ...operation,
    context: {
      ...operation.context,
      requestPolicy: "network-only",
      fromQueue: true,
    },
  });
  queue.delete(operation);
};
